import axios from '_u/axios'
import { downLoadBlob } from '_u/helper'

// 用于接受流
const blob = axios.create({
    responseType: 'blob'
})

// 工单/任务列表
export const orderList = (body) => {
    return axios.post('api/order/info/list', body)
}

// 工单/任务详情
export const orderView = (id) => {
    return axios.post('api/order/info/view', {
        id
    })
}

// 工单/任务新增
export const orderAdd = (body) => {
    return axios.post('api/order/info/add', body)
}

// 工单/任务修改
export const orderUpdate = (body) => {
    return axios.post('api/order/info/update', body)
}

// 工单/任务删除
export const orderDelete = (id) => {
    return axios.post('api/order/info/delete', {
        id
    })
}

// 工单/任务还原
export const restore = (id) => {
    return axios.post('api/order/info/restore', {
        id
    })
}

// 工单/任务彻底删除
export const shiftDelete = (id) => {
    return axios.post('api/order/info/shiftDelete', {
        id
    })
}

// 派发
export const distribute = (body) => {
    return axios.post('api/order/info/distribute', body)
}

// 更换执行人
export const changeExec = (body) => {
    return axios.post('api/order/info/changeExec', body)
}

// 工单/任务分析
export const orderAnalysis = (body) => {
    return axios.post('api/order/info/orderAnalysis', body)
}

// 工单客户评价
export const orderEvaluate = (body) => {
    return axios.post('api/order/info/orderEvaluate', body)
}

// 统计工单监控
export const statisticOrderMonitor = (body) => {
    return axios.post('api/order/info/statisticOrderMonitor', body)
}

// 统计工单咨询
export const statisticOrderConsult = (body) => {
    return axios.post('api/order/info/statisticOrderConsult', body)
}

// 根据工单编号查询咨询列表
export const viewOrderConsult = (id) => {
    return axios.post('api/order/info/viewOrderConsult', { id })
}

// 根据咨询数据编号删除咨询数据
export const msgDelete = (id) => {
    return axios.post('api/notify/msg/delete', { id })
}

// 工单/任务详情(含进度)
export const orderDetails = (id) => {
    return axios.post('api/order/info/details', {
        id
    })
}

// 查看总结
export const querySummary = (orderId) => {
    return axios.post('api/order/progress/querySummary', {
        orderId
    })
}

// 工单/任务监控数据分页查询
export const orderMonitor = (body) => {
    return axios.post('api/order/info/orderMonitor', body)
}

// 内部工单-大屏统计数据
export const insideBI= (body) => {
    return axios.post('api/order/info/statisticIndicatorsForInsideBI', body)
}

// 内部工单-大屏查询
export const orderListForInsideBI = (body) => {
    return axios.post('api/order/info/orderListForInsideBI', body)
}

// 导出Word
export const exportWord = (body) => {
    blob.post('api/order/progress/exportWord', body)
    .then(blob => downLoadBlob(blob, '工单总结.docx'))
}